
import { PageRequest } from "@/store/shared/entity";
import CreateLogistics from "./component/create-logistics.vue";
import EditLogistics from "./component/edit-logistics.vue";
import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins } from "@/lib";

class PageLogisticsRequest extends PageRequest {
  name: string;
}

@Component({
  name: "logistics",
  components: { CreateLogistics, EditLogistics },
})
export default class Logistics extends Mixins(PageResultBaseMixins, PageResultModalMixins) {
  buttons = { ...this.addBtn() };

  data: any = {
    model: new PageLogisticsRequest(),
    queryAction: "system/logistics/getAll",
    isAutoQuery: true,
    cols: this.columns,
  };

  get columns() {
    return [
      { title: this.L("app.Logistics.Name"), key: "name", width: 600 },

      {
        title: this.L("app.Logistics.IsTrailer"),
        key: "isTrailer",
        width: 150,
        render: (h: any, params: any) => {
          return h("span", params.row.isTrailer ? "是" : "否");
        },
      },
      { title: this.L("app.Logistics.Remark"), key: "remark" },
      this.$util.render.actions(this.colButtons),
    ];
  }

  colButtonCheck = (row) => {
    return !row.isStatic;
  };

  get colButtons(): ActionButtonConfig[] {
    return [this.colEditBtnM((row) => this.colButtonCheck(row)), this.colDeleteBtn((row) => this.colButtonCheck(row))];
  }

  async created() {}

  reset() {
    this.data.model = new PageLogisticsRequest();
  }
}
